import {endOfDay, set, startOfDay} from 'date-fns';
import {fromZonedTime, toZonedTime} from 'date-fns-tz';

export const JST_TIMEZONE = 'Asia/Tokyo';

export const getCurrentYear = () => new Date().getFullYear();

export const toDateTimeString = (date: Date) =>
    date
        .toLocaleString('ja-JP', {
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            month: '2-digit',
            year: 'numeric',
        })
        .replaceAll('/', '-');

export const setToStartOfDay = (date: Date): Date => {
    const inputZoned = toZonedTime(date, JST_TIMEZONE);
    const outputZoned = startOfDay(inputZoned);

    return fromZonedTime(outputZoned, JST_TIMEZONE);
};

export const setToEndOfDay = (date: Date): Date => {
    const inputZoned = toZonedTime(date, JST_TIMEZONE);
    const outputZoned = set(endOfDay(inputZoned), {milliseconds: 0});

    return fromZonedTime(outputZoned, JST_TIMEZONE);
};

export const toUnixTimestamp = (date: Date | null): string =>
    date ? String(Math.floor(date.getTime()) / 1000) : '';

export const fromUnixTimestamp = (unixTimestamp: string | null): Date | null =>
    unixTimestamp ? new Date(Number.parseInt(unixTimestamp, 10) * 1000) : null;
